import "./contact.css";
import {AiOutlineGithub} from "react-icons/ai"
import {BsLinkedin} from "react-icons/bs"
import {ImTwitter} from "react-icons/im"
import { useRef, useState } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
    const formRef = useRef();
    
  const [done, setDone] = useState(false)

    const handleSubmit = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_q575c2e', 'template_6kfcpe9', formRef.current, 'MyEztOuR1Or5tLRxw')
    .then(function(response) {
       console.log(response.text);
        setDone(true)
    }, function(error) {
       console.log( error);
    });
    
      };
    
 

  return (
    <div className="c">
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">Let's discuss your project</h1>
          <div className="c-info">
            <div className="c-info-item">
             
              +234 811 289 9736
            </div>
            <div className="c-info-item">
             
              yesincourage@gmail.com
            </div>
            
            <div className="c-social">
            <div className="c-info-item">
             <a href="https://github.com/PrinceRequiem7/PrinceRequiem7"><AiOutlineGithub size={22}/> </a>
           
           </div>
           <div className="c-info-item">
           <a href="https://linkedin.com/in/courage-yesin-38a12a231"> <BsLinkedin size={22}/> </a>
          
           
           </div>
           <div className="c-info-item">
           <a href="https://mobile.twitter.com/princerequiem7"><ImTwitter size={22}/>  </a>
             
           
           </div>
            </div>
           
           
          </div>
        </div>
        <div className="c-right">
          <p className="c-desc">
            <b>What do you want to build?</b> Get in touch. Always available for
            freelancing if the right project comes along.
          </p>
          

          <form ref={formRef} onSubmit={handleSubmit} >
            <input  type="text" placeholder="Name" name="user_name" />
            <input  type="text" placeholder="Subject" name="user_subject" />
            <input  type="text" placeholder="Email" name="user_email" />
            <textarea  rows="5" placeholder="Message" name="message" />
            <button>Submit</button>
            {done && "Thank you..."}
           
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;